import { STJUDE_PRODUCT_CODE, STJUDE_ROUND_UP_SIZE_CODE } from "constants/menu";

export const filterStJudeProduct = ({ productCode }) =>
  productCode !== STJUDE_PRODUCT_CODE;

export const filterStJudeRoundUpSize = ({ sizeCode }) =>
  sizeCode !== STJUDE_ROUND_UP_SIZE_CODE;
